import React, { useState } from 'react'
import { useDebounce } from 'use-debounce';
import { useGetLatestNewsQuery } from '../../Redux/getApi';
import "dayjs/locale/ur";
import dayjs from "dayjs";
import { NavLink } from 'react-router-dom';
import { HiDotsVertical } from 'react-icons/hi';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { BsArrowUpLeft, BsArrowUpRight } from 'react-icons/bs';

const LanguageOptions = [
  {value:"",label:"All"},
  { value: "english", label: "English" },
  { value: "urdu", label: "Urdu" },
];


const LatestNews = () => {
     const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebounce(search, 1500);
  const [language, setLanguage] = useState("");

  const handlePrev = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (page < data?.totalPages) setPage((prev) => prev + 1);
  };

  const { data, error, isLoading, isFetching } = useGetLatestNewsQuery({
    page,
    search: debouncedSearch,
    language: language || "",
  });
  const loading = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  return (
    <div className="flex flex-col gap-10  md:py-20 py-10 xl:px-[5%] lg:px-[3%] md:px-[2%] px-[6%] ">
         <div className="flex flex-col gap-4">
           <h1 className="xl:text-[2.5rem] lg:text-[1.8rem]  text-[2rem] font-bold text-center">
             Latest News
           </h1>
           <p className="xl:text-[1.2rem] md:text-[1rem] text-[.9rem] text-center text-[#7A7A7A]">
             Stay updated with the latest news, announcements, and developments.
           </p>
         </div>
   
        
         <div className=" flex justify-end gap-2 w-full">
            <select
             name="language"
             value={language}
             disabled={isLoading}
             onChange={(e) => setLanguage(e.target.value)}
             className=" border-2 rounded-xl border-[#05004e40]  p-2 outline-nonew-28 outline-none md:text-[1rem] text-[.8rem] "
           >
                {LanguageOptions.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
             
           </select>
          <input
            type="search"
            placeholder="Search by title..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(1);
            }}
            className="border-2 rounded-xl border-[#05004e40]  p-2 outline-none md:w-[24rem] md:text-[1rem] text-[.8rem] w-[18rem]"
          />
        </div>
   
         {isLoading || isFetching ? (
           <div className=" grid md:grid-cols-2 grid-cols-1 lg:gap-8 gap-6 ">
             {loading.map((i) => (
               <div
                 key={i}
                 className="bg-[#EFEFEF] animate-pulse p-3 rounded-xl flex flex-col gap-1.5"
               >
                 <p className=" bg-[#97979750] h-5 rounded-lg animate-pulse w-[90%]"></p>
                 <p className=" bg-[#97979750] h-4 rounded-lg animate-pulse w-[70%]"></p>
                 <p className=" bg-[#97979750] h-4 rounded-lg animate-pulse w-[50%]"></p>
               </div>
             ))}
           </div>
         ) : (
              data && (
            <>
              {data?.totalPages === 0 ? (
                <div className=" text-center w-full lg:text-[3rem] md:text-[2rem] text-[1.4rem] font-semibold text-[#05004E]">
                  No Latest News Found
                </div>
              ) : (
                <div className=" grid lg:grid-cols-2 grid-cols-1 lg:gap-3 gap-2">
                  {data?.latestNews?.map((news) => (
                    news?.language === "english" ? (

                      <div
                      key={news?._id}
                      className="bg-[#DEE9E4] lg:p-3 p-2 rounded-xl flex flex-col lg:gap-1.5 gap-1 lg:text-sm text-[12px]"
                      >
                      <div className=" flex justify-between items-center gap-2">
                        <h1 className=" text-[#00643B] font-medium xl:text-[1.4rem] lg:text-[1.2rem] text-[1.1rem]">
                          Latest News
                        </h1>
                        <NavLink
                          to={news?.doc?.docUrl ? news.doc.docUrl : "/"}
                      target="_blank"
                          >
                          <BsArrowUpRight className=" md:size-7 size-5 text-[#00643B]" />
                        </NavLink>
                      </div>
                      <p className=" capitalize">{news?.title}</p>
                      <div>
  Release Date: {dayjs(news?.createdAt).format("MMMM D, YYYY")}
</div>
 <NavLink
                   to={news?.doc?.docUrl ? news.doc.docUrl : "/"}
                      target="_blank"
                  className="p-2 px-4 rounded-lg w-max text-[0.8rem] bg-[#00643B] text-white"
                >
                  Learn more
                </NavLink>
                    </div>
                        ):(
                           <div
                      key={news?._id}
                      className="bg-[#DEE9E4] lg:p-3 p-2 rounded-xl flex flex-col lg:gap-1.5 gap-1 lg:text-sm text-[12px]"
                      >
                      <div className=" flex justify-between items-center gap-2">
                        <NavLink
                         to={news?.doc?.docUrl ? news.doc.docUrl : "/"}
                      target="_blank"
                          >
                          <BsArrowUpLeft className=" md:size-7 size-5  text-[#00643B]" />
                        </NavLink>
                        <h1 className=" text-[#00643B] font-medium xl:text-[1.6rem] lg:text-[1.4rem] text-[1.2rem]">
                          تازہ ترین خبریں
                        </h1>
                      </div>
                      <p className=" capitalize text-right md:text-lg">{news?.title}</p>
                      <div className=" text-right">تاریخ : {dayjs(news?.createdAt).locale("ur").format("D MMMM YYYY")}</div>
                       <NavLink
                   to={news?.doc?.docUrl ? news.doc.docUrl : "/"}
                      target="_blank"
                  className="p-2 px-4 rounded-lg w-max text-[0.8rem] ml-auto bg-[#00643B] text-white"
                >
                  مزید جانیں
                </NavLink>
                    </div>
                        )
                  ))}
                </div>
              )}

              <div className=" flex justify-between items-center">
                <div className=" text-[#0000004f]">
                  Showing record page {data?.currentPage} 0f {data?.totalPages}
                </div>
                <div className=" flex items-center gap-4">
                  <div
                    onClick={handlePrev}
                    disabled={page === 1}
                    className={`bg-[#02643B1F] p-2 text-[#00643b] rounded-xl ${
                      page === 1
                        ? " cursor-not-allowed opacity-50"
                        : "cursor-pointer"
                    }`}
                  >
                    <IoIosArrowBack className="size-6" />
                  </div>
                  {data?.currentPage}
                  <div
                    onClick={handleNext}
                    disabled={page === data?.totalPages}
                    className={`bg-[#02643B1F] p-2 text-[#00643b] rounded-xl ${
                      page === data?.totalPages
                        ? " cursor-not-allowed opacity-50"
                        : "cursor-pointer"
                    }`}
                  >
                    <IoIosArrowForward className="size-6" />
                  </div>
                </div>
              </div>
            </>
          )
           
         )}
   
        
         {error && (
           <p className=" text-red-500 text-center md:text-[1rem] text-sm bg-red-100 p-2 rounded-lg">
             {error?.data?.message || error?.data?.error}
           </p>
         )}
       </div>
  )
}

export default LatestNews
